import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userCartSelect, userCartSet, userCartJoin, userCartDelete, userCollectJoin, userCartClear } from "@/pages/cart/api";
import { message } from "antd";
import { language } from "./language";

const initialState = {
  list: [],
  selectProducts: [],
  selectCartList: JSON.parse(window.localStorage.getItem("cartList") || "[]"),
};

export const asyncInit = createAsyncThunk("cart/asyncInit", async (_, state) => {
  const { cart: { list = [] }, } = state.getState();
  const { data: { data = {}, code }, } = await userCartSelect();
  if (+code === 0) {
    const { list = [] } = data;
    return list;
  } else {
    return list;
  }
});

export const asyncCartSet = createAsyncThunk("cart/asyncCartSet", async (params = {}, state) => {
  const { _index_supplier, modify_number, modify_number: number, sale_max_count_day, stock_num, sale_min_count, cart_id, _index_product } = params;
  const minNumber = Math.max(sale_min_count, 1);
  const { cart: { list = [] }, lang: { value }, } = state.getState();
  const $t = (key) => language[value][key];
  const postData = { number, cart_id };
  if (sale_max_count_day > 0 && modify_number > sale_max_count_day) {
    message.open({ type: "error", content: $t("Exceed Max Quantity"), });
    postData.number = Math.min(sale_max_count_day, stock_num);
  } else if (modify_number > +stock_num) {
    message.open({ type: "error", content: $t("Exceed Stock"), });
    postData.number = Math.min(sale_max_count_day, stock_num);
  }
  if (+modify_number === +params.number) {
    return list;
  }
  const { data: { code }, } = await userCartSet(postData);
  if (+code === 0) {
    return list.map((item) => ({ ...item, sale_list: item._index_supplier === _index_supplier ? item.sale_list.map((subItem) => ({ ...subItem, number: subItem._index_product === _index_product ? Math.max(postData.number, minNumber) : subItem.number })) : item.sale_list }));
  } else {
    return list;
  }
});

export const asyncCartJoin = createAsyncThunk("cart/asyncCartJoin", async (params = [], state) => {
  await userCartJoin({ data: params });
  state.dispatch(asyncInit());
});

export const asyncCartDelete = createAsyncThunk("cart/asyncCartDelete", async (params = {}, state) => {
  const { _index_supplier, cart_id, _index_product } = params;
  const { cart: { list = [], selectProducts = [] }, } = state.getState();
  const { data: { code }, } = await userCartDelete({ cart_ids: [cart_id] });
  if (+code === 0) {
    return {
      list: list.map((item) => ({ ...item, sale_list: item._index_supplier === _index_supplier ? item.sale_list.filter((subItem) => subItem._index_product !== _index_product) : item.sale_list })).filter((item) => item.sale_list.length),
      selectProducts: selectProducts.filter((item) => item._index_product !== _index_product),
    };
  } else {
    return { list, selectProducts };
  }
});

export const asyncUserCollectJoin = createAsyncThunk("cart/asyncUserCollectJoin", async (params = {}, state) => {
  const { _index_supplier, sale_id, sale_unit, in_collect, _index_product } = params;
  const { cart: { list = [] }, } = state.getState();
  const { data: { code, msg }, data, } = await userCollectJoin({ data: [{ sale_id, sale_unit }], option: in_collect ? 2 : 1 });
  if (+code === 0) {
    const newList = list.map((item) => ({ ...item, sale_list: item._index_supplier === _index_supplier ? item.sale_list.map((subItem) => ({ ...subItem, in_collect: subItem._index_product === _index_product ? !in_collect : subItem.in_collect })) : item.sale_list }));
    return { list: newList, data, };
  } else {
    message.open({ type: "error", content: msg, });
    return { list, data, };
  }
});

export const asyncUserCartClear = createAsyncThunk("cart/asyncUserCartClear", async (_, state) => {
  const { cart: { list = [], selectProducts = [] }, } = state.getState();
  const { data: { code }, } = await userCartClear();
  if (+code === 0) {
    return { list: [], selectProducts: [] };
  } else {
    return { list, selectProducts };
  }
});

export const slice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    updateSelectProducts: (state, action) => {
      state.selectProducts = action.payload;
    },
    updateSubmitList: (state, action) => {
      state.selectCartList = action.payload;
      window.localStorage.setItem("cartList", JSON.stringify(state.selectCartList));
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(asyncInit.fulfilled, (state, actions) => {
        state.list = actions.payload;
      })
      .addCase(asyncCartSet.fulfilled, (state, actions) => {
        state.list = actions.payload;
      })
      .addCase(asyncCartDelete.fulfilled, (state, actions) => {
        const { payload: { list = [], selectProducts = [] }, } = actions;
        state.list = list;
        state.selectProducts = selectProducts;
      })
      .addCase(asyncUserCollectJoin.fulfilled, (state, actions) => {
        state.list = actions.payload.list;
      })
      .addCase(asyncUserCartClear.fulfilled, (state, actions) => {
        const { payload: { list = [], selectProducts = [] }, } = actions;
        state.list = list;
        state.selectProducts = selectProducts;
      })
      .addCase(asyncCartJoin.fulfilled);
  },
});

const { reducer, actions } = slice;
export const { updateSelectProducts, updateSubmitList } = actions;
export default reducer;
